module.exports = __webpack_public_path__ + "img/widget.2b8b9e08.jpg";